import { __assign } from "tslib";
import { initI18nWithoutICU, initI18n as initI18nWithICU } from '@wix/wix-i18n-config';
import createI18nConfig from './create-i18n-config';
import { icuOptions } from '../constants/icu-options';
export var initI18n = function (lng, localeData, useICU) {
    if (useICU === void 0) { useICU = false; }
    return useICU ? createI18nWithICU(lng, localeData) : createI18nWithoutICU(lng, localeData);
};
var createI18nWithoutICU = function (locale, messages) {
    var i18n = initI18nWithoutICU({ locale: locale, messages: messages });
    i18n.init(__assign({}, createI18nConfig()));
    return i18n;
};
var createI18nWithICU = function (locale, messages) {
    var i18n = initI18nWithICU({ locale: locale, messages: messages, icuOptions: icuOptions });
    i18n.init();
    return i18n;
};
